export const ADD_EVENT_STEARMS_REQUEST = 'ADD_EVENT_STEARMS_REQUEST'
export const ADD_EVENT_STEARMS_SUCCESS = 'ADD_EVENT_STEARMS_SUCCESS'
export const ADD_EVENT_STEARMS_FALIURE = 'ADD_EVENT_STEARMS_FALIURE'